import { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import type { ReactPortal } from 'react';

export const usePortal = (Content: JSX.Element, className = '', target = document.body, tag = 'div'): ReactPortal => {
  const portal = useMemo(() => document.createElement(tag), [ tag ]);

  if (className) {
    portal.classList.add(className);
  }

  useEffect(() => {
    target?.appendChild(portal);
    return () => {
      target?.removeChild(portal);
    };
  }, [ portal, className, target ]);

  return ReactDOM.createPortal(Content, portal);
};
